module.exports = __webpack_public_path__ + "media/crypto/usds-1af8650a.png";